import { create } from 'zustand';

interface MockBannerState {
  /** Loud banner when the MSW worker fails to start (knowledge-tree edge case: no silent white screen). */
  mockFailure: string | null;
  reportMockFailure: (message: string) => void;
}

export const useMockBannerStore = create<MockBannerState>()((set) => ({
  mockFailure: null,
  reportMockFailure: (message) => set({ mockFailure: message }),
}));
